import React from 'react';
import { FormTemplateQuestionFieldsKindEnum } from 'graphql-common';
import Rating from '@lib/components/Rating/Rating';
import { defaultProps } from '../types';

export default function RatingPreview() {
  return (
    <Rating
      {...defaultProps}
      value={undefined}
      name={FormTemplateQuestionFieldsKindEnum.Rating}
    />
  );
}
